import { render, staticRenderFns } from "./VocabularyWordsForm.vue?vue&type=template&id=0deea3ae&scoped=true&lang=pug&"
import script from "./VocabularyWordsForm.vue?vue&type=script&lang=js&"
export * from "./VocabularyWordsForm.vue?vue&type=script&lang=js&"
import style0 from "./VocabularyWordsForm.vue?vue&type=style&index=0&id=0deea3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deea3ae",
  null
  
)

export default component.exports